export const JOB_STATUS = {
  created: 'created',
  running: 'running',
  completed: 'completed',
  failed: 'failed',
};

export const JOB_ERROR_CODE = {
  generalError: 'general_error',
};
